var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.device, {'magento': _vm.isMagento }, _vm.generator],attrs:{"id":"app"}},[_c('router-view'),(_vm.activeTooltip !== null)?_c('popup-tooltip',{attrs:{"tooltip-content":_vm.activeTooltip},on:{"close":function($event){_vm.activeTooltip = null}}}):_vm._e(),(_vm.showSharePopup)?_c('popup-trigger-share'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }